function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconciliationNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.1125V14.1375C8.25 15.825 7.575 16.5 5.8875 16.5H3.8625C2.175 16.5 1.5 15.825 1.5 14.1375V12.1125C1.5 10.425 2.175 9.75 3.8625 9.75H5.8875C7.575 9.75 8.25 10.425 8.25 12.1125Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.25C16.5 14.1525 14.1525 16.5 11.25 16.5L12.0375 15.1875",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.75C1.5 3.8475 3.8475 1.5 6.75 1.5L5.9625 2.8125",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 8.25C14.989 8.25 16.5 6.73896 16.5 4.875C16.5 3.01104 14.989 1.5 13.125 1.5C11.261 1.5 9.75 3.01104 9.75 4.875C9.75 6.73896 11.261 8.25 13.125 8.25Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliationNav);
export default __webpack_public_path__ + "static/media/reconciliation-nav.16859be90e5c723b7a87fc713b27fe1a.svg";
export { ForwardRef as ReactComponent };